import React from 'react';

const CheckboxOutlinedIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17px"
            height="17px"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_2735_37253)">
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#DFDBD6" />
            </g>
            <defs>
                <clipPath id="clip0_2735_37253">
                    <rect width="16" height="16" rx="4" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CheckboxOutlinedIcon;